var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ServiceFetcher = /** @class */ (function () {
    function ServiceFetcher() {
    }
    ServiceFetcher.setup = function (settings) {
        ServiceFetcher.settings = settings;
        var baseUrl = settings.baseUrl;
        if (!baseUrl.endsWith("/"))
            ServiceFetcher.settings.baseUrl += "/";
    };
    ServiceFetcher.getUserContext = function () {
        return ServiceFetcher.settings.userContext;
    };
    ServiceFetcher.fetch = function (options) {
        var _a;
        var methodUrl = options.methodUrl, methodName = options.methodName, authParamName = options.authParamName;
        var settings = ServiceFetcher.settings;
        var parameters = options.parameters || {};
        // include user context to parameters
        authParamName &&
            (parameters = __assign((_a = {}, _a[authParamName] = ServiceFetcher.settings.userContext, _a), parameters));
        if (!ServiceFetcher.settings)
            throw new Error("Service Fetcher is not setup");
        if (!ServiceFetcher.settings.baseUrl)
            throw new Error("Service Fetcher Base Url is not setup");
        // use random number to avoid caching
        var fullMethodUrl = "".concat(ServiceFetcher.settings.baseUrl).concat(methodUrl, "?rand=").concat(Math.floor(Math.random() * 100 + 1));
        var resultName = methodName + "Result";
        // call it!
        settings.before && settings.before(options);
        return ServiceFetcher.postData({
            url: fullMethodUrl,
            data: parameters,
            abortController: options.abortController,
        })
            .then(function (data) {
            settings.success && settings.success(options);
            return data && data[resultName] ? data[resultName] : undefined;
        }, function (err) {
            // There is no need to log AbortError as it is not real error, but just error caused by cancelling request.
            // At the same time we need to throw the error, for example to display "Request has been cancelled" message to user.
            if (err.name !== 'AbortError') {
                settings.error && settings.error(err.responseText, options);
            }
            throw err;
        });
    };
    ServiceFetcher.postData = function (_a) {
        var _b = _a === void 0 ? {
            url: "",
            data: {},
        } : _a, url = _b.url, data = _b.data, abortController = _b.abortController;
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "json",
                // "x-requested-with" header is needed for MVC to understand that request came from our frontend, 
                // in this case MVC backend will send error message with stacktrace as JSON 
                // in the same way like it does for old proxies
                "x-requested-with": 'XMLHttpRequest',
                "js-client-event-session-id": Decisions.GetSessionId(),
                "Force-Studio": window['forceStudio'],
            },
            body: JSON.stringify(data).replace(/\bNaN\b/g, "null"),
            signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
        })
            .then(function (response) {
            if (!response.ok) {
                return response.text().then(function (result) {
                    throw {
                        responseText: result,
                    };
                });
            }
            return response.json();
        });
    };
    return ServiceFetcher;
}());
export { ServiceFetcher };
